import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  Box,
  Card,
  CardContent,
  Typography,
  TextField,
  Button,
  IconButton,
  Divider,
  Grid,
  Chip,
  CircularProgress,
  Alert,
  Paper,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  AppBar,
  Toolbar,
  Container,
  Avatar,
  Menu,
} from '@mui/material';
import {
  Add as AddIcon,
  Delete as DeleteIcon,
  Save as SaveIcon,
  Book as BookIcon,
  Keyboard as KeyboardIcon,
  Speed as SpeedIcon,
  Assignment as AssignmentIcon,
  History as HistoryIcon,
  School as SchoolIcon,
  Close as CloseIcon,
  Home as HomeIcon,
  Person as PersonIcon,
  ExitToApp as LogoutIcon,
  Menu as MenuIcon,
  Style as FlashCardIcon,
  Shuffle as ShuffleIcon,
  FilterList as FilterIcon,
  Star as StarIcon,
  StarBorder as StarBorderIcon,
  ArrowBack as ArrowBackIcon,
  ArrowForward as ArrowForwardIcon,
  Refresh as RefreshIcon,
  TrendingUp as TrendingUpIcon,
  EmojiEvents as EmojiEventsIcon,
} from '@mui/icons-material';
import Drawer from '@mui/material/Drawer';
import axios from 'axios';
import { toast } from 'react-toastify';
import LeaderboardDashboardCard from '../../components/Students/LeaderboardDashboardCard';
import LmsLeaderboardLoginPopup, {
  shouldShowLeaderboardPopup,
} from '../../components/Students/LmsLeaderboardLoginPopup';

const getApiBaseUrl = () => {
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  if (typeof window !== 'undefined' && (window.location.hostname.includes('ondigitalocean.app') || window.location.hostname.includes('services.knls.in'))) {
    return '/api';
  }
  return 'http://localhost:3000/api';
};

const API_BASE_URL = getApiBaseUrl();

const DailyTrackSheet = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState({});
  const [creatingFlashCards, setCreatingFlashCards] = useState({ lesson: false, shortcuts: false });
  const [currentDate, setCurrentDate] = useState(new Date().toISOString().split('T')[0]);
  const [currentTime, setCurrentTime] = useState(new Date().toLocaleTimeString('en-IN'));

  // Course-specific lesson lists
  const courseLessons = {
    DCA: [
      // Fundamentals
      '1 - FUNDAMENTALS HW VS SW',
      '2 - FUNDAMENTALS QWERTY KEYBOARD',
      
      // Windows Components
      '1 Windows Components Part-a',
      '2 Windows Components - b - system tray',
      '3 Windows Components Part- c Class',
      '4 Windows Components Part- d',
      '5 Windows Components Part- e - shut down restart, sleep mode, pc vs mac',
      '6 Windows Components Part- f users, wallpaper, short creation, command buttons...',
      '7 WINDOWS TYPES OF FILES',
      '8. File Management',
      '9 WINDOWS -FILEMANAGEMENT - RENAME AND DELETE',
      '10 WINDOWS -FILEMANAGEMENT copy and move',
      '11 - Windows_Multiple files selction_Sshortcut_Zip_Sort',
      '12 WINDOWS_FILE MANAGEMENT PRINT',
      'Window Control Buttons',
      
      // MS Word
      '1 WORD_BIO_DATA_CLASS',
      '2nd Class - Word',
      '3 A to C Accelrated Keys',
      '4 CTRL + D - FONT DIALOUGE BOX',
      '5 ctrl f FIND & REPLACE',
      '6 Ctrl + g - Goto auto correct add to dictionary class',
      '7 Accelrated keys l_l_l_m class',
      '8 Ctrl_K - Hyper Link',
      '9 CTRL_N_O_P CLASS',
      '10 crl_r_s',
      '11 crl_t_u_v_w_x_y_z',
      '12 auto text',
      '13 Mail Merge class',
      '14) Word Assignments',
      
      // Internet & Email
      '1 Introduction to Internet class',
      '2 Browswers',
      '3 Browsers Class II',
      '4 Introduction to eMAIL',
      '5 Gmail Class',
      
      // MS Excel
      '1 Excel Intro',
      '2 Autosum Class',
      '3 Auto Fill',
      '4 Excel Pagesetup',
      '5 Header and Footer',
      '6 Print Titles Class',
      '7 complete pagestup options Class',
      '8 Pay Roll Preperation',
      '9 Format Cells',
      '10 date & time',
      '11 Age Caliculator',
      '12 accelrated keys',
    ],
    PGDCA: [
      '1) Introdcution To Language',
      '2) 2nd, 3rd, 4th, 5th gls class',
      '3) History of C',
      '4) Basics of Programming',
      '5) Algorithm',
      'C SETUP/INSTALLATION',
      'Sequential Program Explanation: Sum Calculation',
      'Conditional Statements',
      'visual studio code settings',
      'oddoreven program with debugger',
      'marks memo with operators',
      'Switch-Case',
      'LOOP Programs',
      'loop_iterative program',
      'do-while loop',
      'for loop',
      'Arrays',
      'Functions',
      'Passing Values between Functions',
      'Interchange/Swap Program',
      'Pointers',
      'Data types Revised',
      'Storage Classes',
      'Practice Programs for while and for Loops',
      'Print the Fibonacci Series:',
      'Step by Step Exercise Programs',
    ],
    DTP: [
      '1) photo shop intro',
      '2) photoshop env',
      '3) ps layers 1',
      '4)bkground change',
      'ID CARD',
      'id card shortcut',
      'id card template',
      'BLACK AND WHITE TO COLOR',
      'LETTER HEAD - USING WITH TEXT EFFECTS',
      'TEXT LAYER BLENDING OPTIONS',
      'PASSPORT PHOTOS WITH ACTION',
    ],
    TALLY: [],
    WEB_DESIGNING: [
      'WEB DESIGN INTRO',
      'web designing intro',
      'THOMOS ALWA EDITION PROJECT',
      '2023-08-28_08-02-43',
      'bulb images setup',
      'Purpose of Visual Studio Code Setup',
      'Vs Code DL_INSTALL_SETTINGS',
      'Building Blocks of the Web: HTML Fundamentals',
      'Anatomy of an HTML Element',
      'HTML Structure - Overview',
      'Html Structure - Head',
      'Html Structure - 3',
      'Images and Attributes',
      'Anchor Tag',
      'GitHub',
      'Semantic Element and Structuring',
      'CSS-Inline-Internal-External',
      'CSS- COLOR : RGB AND RGBA',
      'CSS- Terminology Break-Down',
      'CSS- Font-Family & Font-Size',
      'CSS- Miscellaneous Text Properties',
      'Assignment',
      'Css- Cards',
      'Css - Interactive - Flip Card',
      'Website Layout Challenge',
      'full layout challenge',
      'Full Website Layout - Part 1',
      'Full Website Layout - Part 2',
      'Figma Assignment',
    ],
  };

  // Available courses
  const availableCourses = [
    { code: 'DCA', name: 'DCA - Diploma in Computer Applications' },
    { code: 'PGDCA', name: 'PGDCA - Post Graduate Diploma in Computer Applications' },
    { code: 'DTP', name: 'DTP - Desktop Publishing' },
    { code: 'TALLY', name: 'Tally' },
    { code: 'WEB_DESIGNING', name: 'Web Designing' },
  ];

  // Course selection
  const [selectedCourse, setSelectedCourse] = useState('');
  const [enrolledCourses, setEnrolledCourses] = useState([]);
  
  // All lessons list (from database - previously saved)
  const [allLessons, setAllLessons] = useState([]);
  // Main lesson selection (for sections 1, 2, 3)
  const [selectedMainLesson, setSelectedMainLesson] = useState('');

  // Get lessons for selected course
  const getLessonsForCourse = () => {
    if (!selectedCourse) return [];
    const courseLessonsList = courseLessons[selectedCourse] || [];
    // Combine with saved lessons from database
    const savedLessons = allLessons
      .filter(l => l.lessonName && !courseLessonsList.includes(l.lessonName))
      .map(l => l.lessonName);
    return [...courseLessonsList, ...savedLessons];
  };

  // Section 1: Lesson Details
  const [lessonName, setLessonName] = useState('');
  const [lessonPoints, setLessonPoints] = useState([{ subject: '', explanation: '' }]);

  // Section 2: Shortcuts
  const [shortcuts, setShortcuts] = useState([{ shortcut_key: '', use_case: '' }]);

  // Section 3: Speed Practice
  const [speedPractices, setSpeedPractices] = useState([
    { practice_type: 'letters', lesson_name: '', speed: '', custom_lesson_name: '' },
  ]);

  // Section 4: Exam Results
  const [examResults, setExamResults] = useState([
    { exam_name: '', obtained_marks: '', total_marks: '' },
  ]);

  // Flash Cards
  const [flashCardsOpen, setFlashCardsOpen] = useState(false);
  const [flashCards, setFlashCards] = useState([]);
  const [filteredFlashCards, setFilteredFlashCards] = useState([]);
  const [currentCardIndex, setCurrentCardIndex] = useState(0);
  const [showFlashCardBack, setShowFlashCardBack] = useState(false);
  const [isFlipping, setIsFlipping] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [selectedCourseForFlashCards, setSelectedCourseForFlashCards] = useState('');
  const [selectedLessonForFlashCards, setSelectedLessonForFlashCards] = useState('all');
  const [shuffleMode, setShuffleMode] = useState(false);
  const [shuffleAllLessons, setShuffleAllLessons] = useState(false);
  const [studyStats, setStudyStats] = useState({ total: 0, reviewed: 0, mastered: 0 });

  // Student data and menu
  const [studentData, setStudentData] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const menuOpen = Boolean(anchorEl);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [showLeaderboardPopup, setShowLeaderboardPopup] = useState(false);

  useEffect(() => {
    // Check authentication
    const token = localStorage.getItem('student_token');
    if (!token) {
      navigate('/student/login');
      return;
    }

    // Update time every minute
    const timeInterval = setInterval(() => {
      setCurrentTime(new Date().toLocaleTimeString('en-IN'));
    }, 60000);

    loadStudentData();
    loadTodayTrackSheet();
    // Flash cards are loaded when dialog opens, not on mount

    if (shouldShowLeaderboardPopup()) {
      setShowLeaderboardPopup(true);
    }

    return () => clearInterval(timeInterval);
  }, [navigate]);

  const loadStudentData = async () => {
    try {
      const studentDataStr = localStorage.getItem('student_data');
      if (studentDataStr) {
        const data = JSON.parse(studentDataStr);
        setStudentData(data);
        
        // Load enrolled courses
        const courses = data.enrolled_courses || [];
        console.log('📚 Student enrolled courses (raw):', courses);
        console.log('📚 Student data:', data);
        console.log('📚 Available course codes:', availableCourses.map(c => c.code));
        // Normalize course codes to uppercase for comparison
        const normalizedCourses = courses.map(c => String(c).toUpperCase().trim());
        console.log('📚 Normalized enrolled courses:', normalizedCourses);
        setEnrolledCourses(normalizedCourses);
        
        // Set default course (first enrolled course)
        // Find matching course code from availableCourses
        if (normalizedCourses.length > 0 && !selectedCourse) {
          const firstEnrolled = normalizedCourses[0];
          const matchingCourse = availableCourses.find(
            c => c.code.toUpperCase().trim() === firstEnrolled
          );
          if (matchingCourse) {
            setSelectedCourse(matchingCourse.code);
            console.log('📚 Default course set to:', matchingCourse.code);
          } else {
            console.warn('⚠️ No matching course found for enrolled:', firstEnrolled);
          }
        }

      }
    } catch (error) {
      console.error('Error loading student data:', error);
    }
  };

  const loadAllLessons = async () => {
    try {
      const token = localStorage.getItem('student_token');
      if (!token) return;

      const response = await axios.get(`${API_BASE_URL}/track-sheets/lessons`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response.data.success) {
        setAllLessons(response.data.lessons || []);
        console.log('📚 Loaded lessons:', response.data.lessons);
      }
    } catch (error) {
      console.error('Error loading lessons:', error);
    }
  };

  const loadLessonData = async (lessonName, section) => {
    try {
      const token = localStorage.getItem('student_token');
      if (!token || !lessonName) return;

      const response = await axios.get(`${API_BASE_URL}/track-sheets/lesson/${encodeURIComponent(lessonName)}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response.data.success && response.data.lesson) {
        const lesson = response.data.lesson;

        if (section === 1) {
          // Load lesson details
          setLessonName(lesson.lesson_name || '');
          if (lesson.points && lesson.points.length > 0) {
            setLessonPoints(lesson.points.map((p) => p.point_text || ''));
          } else {
            setLessonPoints(['']);
          }
        } else if (section === 2) {
          // Load shortcuts
          if (lesson.shortcuts && lesson.shortcuts.length > 0) {
            setShortcuts(
              lesson.shortcuts.map((s) => ({
                shortcut_key: s.shortcut_key || '',
                use_case: s.use_case || '',
              }))
            );
          } else {
            setShortcuts([{ shortcut_key: '', use_case: '' }]);
          }
        } else if (section === 3) {
          // Load speed practice
          if (lesson.speedPractice && lesson.speedPractice.length > 0) {
            setSpeedPractices(
              lesson.speedPractice.map((sp) => ({
                practice_type: sp.practice_type || 'letters',
                lesson_name: sp.lesson_name || '',
                speed: sp.speed || '',
                custom_lesson_name: '',
              }))
            );
          } else {
            setSpeedPractices([{ practice_type: 'letters', lesson_name: lessonName, speed: '', custom_lesson_name: '' }]);
          }
        }
      }
    } catch (error) {
      console.error(`Error loading lesson data for section ${section}:`, error);
      toast.error('Failed to load lesson data');
    }
  };

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    localStorage.removeItem('student_token');
    localStorage.removeItem('student_data');
    toast.success('Logged out successfully');
    navigate('/student/login');
  };

  const loadMainLessonData = async (lessonName) => {
    if (!lessonName) {
      // Clear all sections
      setLessonName('');
      setLessonPoints(['']);
      setShortcuts([{ shortcut_key: '', use_case: '' }]);
      setExamResults([{ exam_name: '', obtained_marks: '', total_marks: '' }]);
      return;
    }

    try {
      const token = localStorage.getItem('student_token');
      if (!token) return;

      // Set lesson name in all sections
      setLessonName(lessonName);
      setExamResults([{ exam_name: lessonName, obtained_marks: '', total_marks: '' }]);

      // Try to load saved data for this lesson
      const response = await axios.get(`${API_BASE_URL}/track-sheets/lesson/${encodeURIComponent(lessonName)}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response.data.success && response.data.lesson) {
        const lesson = response.data.lesson;

        // Load lesson details (Section 1)
        if (lesson.points && lesson.points.length > 0) {
          setLessonPoints(lesson.points.map((p) => {
            if (typeof p.point_text === 'string') {
              try {
                const parsed = JSON.parse(p.point_text);
                if (parsed.subject && parsed.explanation) {
                  return { subject: parsed.subject, explanation: parsed.explanation };
                }
              } catch {
                return { subject: p.point_text || '', explanation: '' };
              }
            }
            return { subject: p.point_subject || p.point_text || '', explanation: p.point_explanation || '' };
          }));
        } else {
          setLessonPoints([{ subject: '', explanation: '' }]);
        }

        // Load shortcuts (Section 2)
        if (lesson.shortcuts && lesson.shortcuts.length > 0) {
          setShortcuts(
            lesson.shortcuts.map((s) => ({
              shortcut_key: s.shortcut_key || '',
              use_case: s.use_case || '',
            }))
          );
        } else {
          setShortcuts([{ shortcut_key: '', use_case: '' }]);
        }

        // Load exam results (Section 4)
        if (lesson.examResults && lesson.examResults.length > 0) {
          setExamResults(
            lesson.examResults.map((er) => ({
              exam_name: er.exam_name || lessonName,
              obtained_marks: er.obtained_marks?.toString() || '',
              total_marks: er.total_marks?.toString() || '',
            }))
          );
        } else {
          setExamResults([{ exam_name: lessonName, obtained_marks: '', total_marks: '' }]);
        }
      } else {
        // New lesson - initialize empty
        setLessonPoints([{ subject: '', explanation: '' }]);
        setShortcuts([{ shortcut_key: '', use_case: '' }]);
        setExamResults([{ exam_name: lessonName, obtained_marks: '', total_marks: '' }]);
      }
    } catch (error) {
      console.error('Error loading lesson data:', error);
      // Initialize empty for new lesson
      setLessonPoints([{ subject: '', explanation: '' }]);
      setShortcuts([{ shortcut_key: '', use_case: '' }]);
    }
  };

  const loadTodayTrackSheet = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem('student_token');
      
      if (!token) {
        toast.error('Please login to access track sheet');
        navigate('/student/login');
        return;
      }

      const response = await axios.get(`${API_BASE_URL}/track-sheets/today`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response.data.success && response.data.trackSheet) {
        const sheet = response.data.trackSheet;

        console.log('📋 Track sheet data loaded:', {
          hasLessonDetails: !!sheet.lessonDetails,
          lessonDetailsCount: sheet.lessonDetails?.length || 0,
          lessonDetails: sheet.lessonDetails,
        });

        // Load lesson details
        if (sheet.lessonDetails && sheet.lessonDetails.length > 0) {
          const lesson = sheet.lessonDetails[0];
          console.log('📚 First lesson detail:', {
            id: lesson.id,
            lesson_name: lesson.lesson_name,
            lessonNameType: typeof lesson.lesson_name,
            points: lesson.points,
          });
          setLessonName(lesson.lesson_name || '');
          if (lesson.points && lesson.points.length > 0) {
            setLessonPoints(lesson.points.map((p) => {
              if (typeof p.point_text === 'string') {
                try {
                  const parsed = JSON.parse(p.point_text);
                  if (parsed.subject && parsed.explanation) {
                    return { subject: parsed.subject, explanation: parsed.explanation };
                  }
                } catch {
                  return { subject: p.point_text || '', explanation: '' };
                }
              }
              return { subject: p.point_subject || p.point_text || '', explanation: p.point_explanation || '' };
            }));
          } else {
            setLessonPoints([{ subject: '', explanation: '' }]);
          }
        } else {
          console.log('⚠️ No lesson details found in track sheet');
          // Reset to empty if no data
          setLessonName('');
          setLessonPoints([{ subject: '', explanation: '' }]);
        }

        // Load shortcuts
        if (sheet.shortcuts && sheet.shortcuts.length > 0) {
          setShortcuts(
            sheet.shortcuts.map((s) => ({
              shortcut_key: s.shortcut_key || '',
              use_case: s.use_case || '',
            }))
          );
        } else {
          setShortcuts([{ shortcut_key: '', use_case: '' }]);
        }

        // Load speed practice
        if (sheet.speedPractice && sheet.speedPractice.length > 0) {
          setSpeedPractices(
            sheet.speedPractice.map((sp) => ({
              practice_type: sp.practice_type || 'letters',
              lesson_name: sp.lesson_name || '',
              speed: sp.speed || '',
              custom_lesson_name: '',
            }))
          );
        } else {
          setSpeedPractices([{ practice_type: 'letters', lesson_name: '', speed: '', custom_lesson_name: '' }]);
        }

        // Load exam results
        if (sheet.examResults && sheet.examResults.length > 0) {
          setExamResults(
            sheet.examResults.map((er) => ({
              exam_name: er.exam_name || '',
              obtained_marks: er.obtained_marks?.toString() || '',
              total_marks: er.total_marks?.toString() || '',
            }))
          );
        } else {
          setExamResults([{ exam_name: '', obtained_marks: '', total_marks: '' }]);
        }
      } else {
        // No track sheet for today - initialize empty forms
        setLessonName('');
        setLessonPoints([{ subject: '', explanation: '' }]);
        setShortcuts([{ shortcut_key: '', use_case: '' }]);
        setSpeedPractices([{ practice_type: 'letters', lesson_name: '', speed: '', custom_lesson_name: '' }]);
        setExamResults([{ exam_name: '', obtained_marks: '', total_marks: '' }]);
      }
    } catch (error) {
      console.error('Error loading track sheet:', error);
      console.error('Error details:', {
        message: error.message,
        response: error.response?.data,
        status: error.response?.status,
      });
      
      // Initialize empty forms on error
      setLessonName('');
      setLessonPoints([{ subject: '', explanation: '' }]);
      setShortcuts([{ shortcut_key: '', use_case: '' }]);
      setSpeedPractices([{ practice_type: 'letters', lesson_name: '', speed: '', custom_lesson_name: '' }]);
      setExamResults([{ exam_name: '', obtained_marks: '', total_marks: '' }]);
      
      if (error.response?.status === 401) {
        toast.error('Session expired. Please login again.');
        navigate('/student/login');
      } else if (error.response?.status === 404) {
        // No track sheet exists for today - this is normal, don't show error
        console.log('No track sheet found for today - this is normal for new days');
      } else if (error.response?.data?.message) {
        toast.error(error.response.data.message);
      } else if (error.message.includes('Network Error') || error.code === 'ECONNABORTED') {
        toast.error('Cannot connect to server. Please check your internet connection.');
      } else {
        toast.error('Failed to load track sheet. You can still create a new one.');
      }
    } finally {
      setLoading(false);
    }
  };

  const loadFlashCards = async () => {
    try {
      const token = localStorage.getItem('student_token');
      if (!token) {
        console.error('❌ No student token found in localStorage');
        toast.error('Please login to view flash cards');
        return;
      }

      // Decode token to check student ID (for debugging)
      try {
        const tokenParts = token.split('.');
        if (tokenParts.length === 3) {
          const payload = JSON.parse(atob(tokenParts[1]));
          console.log('🔍 Student ID from token:', payload.userId);
          console.log('🔍 Student role from token:', payload.role);
        }
      } catch (e) {
        console.warn('Could not decode token:', e);
      }

      console.log('📡 Loading flash cards from:', `${API_BASE_URL}/track-sheets/flash-cards`);
      
      const response = await axios.get(`${API_BASE_URL}/track-sheets/flash-cards`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      console.log('✅ Flash cards API response:', {
        success: response.data.success,
        flashCardsCount: response.data.flashCards?.length || 0,
        flashCards: response.data.flashCards,
        fullResponse: response.data,
      });

      if (response.data.success) {
        let cards = response.data.flashCards || [];
        console.log(`📚 Loaded ${cards.length} flash card(s)`);
        
        // Filter out old format cards (cards with "Lesson:" or "From lesson:" in frontText or backText)
        cards = cards.filter(card => {
          const frontText = card.front_text?.toLowerCase() || '';
          const backText = card.back_text?.toLowerCase() || '';
          // Exclude cards that start with "lesson:" or contain "from lesson:" or "important points:"
          const isOldFormat = 
            frontText.startsWith('lesson:') || 
            frontText.includes('from lesson:') ||
            backText.includes('important points:') ||
            backText.startsWith('from lesson:');
          return !isOldFormat;
        });
        
        console.log(`📚 After filtering old format: ${cards.length} flash card(s)`);
        
        if (cards.length > 0) {
          console.log('📋 Flash cards details:', cards.map(c => ({
            id: c.id,
            front: c.front_text?.substring(0, 30),
            back: c.back_text?.substring(0, 30),
            category: c.category,
            student_id: c.student_id,
          })));
        }
        
        setFlashCards(cards);
        applyFilters(cards, selectedCategory, selectedCourseForFlashCards, selectedLessonForFlashCards, shuffleMode, shuffleAllLessons);
        
        // Calculate stats
        const mastered = cards.filter(c => c.mastery_level >= 3).length;
        setStudyStats({
          total: cards.length,
          reviewed: cards.filter(c => c.times_reviewed > 0).length,
          mastered: mastered,
        });
        
        if (cards.length === 0) {
          console.warn('⚠️ No flash cards found in database');
          toast.info('No flash cards found. Create some from your track sheets!');
        } else {
          console.log('✅ Flash cards loaded successfully');
        }
      } else {
        console.error('❌ API returned success:false', response.data);
        toast.error(response.data.message || 'Failed to load flash cards');
      }
    } catch (error) {
      console.error('❌ Error loading flash cards:', error);
      console.error('❌ Error details:', {
        message: error.message,
        response: error.response?.data,
        status: error.response?.status,
        statusText: error.response?.statusText,
        config: {
          url: error.config?.url,
          method: error.config?.method,
          headers: error.config?.headers,
        },
      });
      
      if (error.response?.status === 401) {
        console.error('❌ Authentication failed - token invalid or expired');
        toast.error('Session expired. Please login again.');
        navigate('/student/login');
      } else if (error.response?.status === 500) {
        console.error('❌ Server error:', error.response.data);
        toast.error(error.response.data?.message || 'Server error. Please try again later.');
      } else if (error.response?.data?.message) {
        console.error('❌ API error message:', error.response.data.message);
        toast.error(error.response.data.message);
      } else if (error.message.includes('Network Error')) {
        console.error('❌ Network error - backend might be down');
        toast.error('Cannot connect to server. Please check if backend is running.');
      } else {
        console.error('❌ Unknown error:', error);
        toast.error('Failed to load flash cards. Please check console for details.');
      }
    }
  };

  const applyFilters = useCallback((cards, category = selectedCategory, course = selectedCourseForFlashCards, lesson = selectedLessonForFlashCards, shuffle = shuffleMode, shuffleAll = shuffleAllLessons) => {
    if (!cards || !Array.isArray(cards) || cards.length === 0) {
      setFilteredFlashCards([]);
      setCurrentCardIndex(0);
      return;
    }

    let filtered = [...cards];
    
    // If shuffleAll is enabled, ignore course/lesson filters and show cards from all lessons
    if (shuffleAll) {
      // Only apply category filter when shuffle all is enabled
      if (category && category !== 'all') {
        filtered = filtered.filter(card => card && card.category === category);
      }
      // Shuffle all cards from all lessons
      filtered = filtered.sort(() => Math.random() - 0.5);
    } else {
      // Apply category filter
      if (category && category !== 'all') {
        filtered = filtered.filter(card => card && card.category === category);
      }
      
      // Apply course filter - filter by lessons that belong to the selected course
      if (course && course !== '') {
        const courseLessonsList = courseLessons[course] || [];
        filtered = filtered.filter(card => {
          if (!card) return false;
          const frontText = card.front_text?.toLowerCase() || '';
          const backText = card.back_text?.toLowerCase() || '';
          // Check if card belongs to any lesson in the selected course
          return courseLessonsList.some(lessonName => {
            const lessonNameLower = lessonName.toLowerCase();
            return frontText.includes(lessonNameLower) || 
                   backText.includes(lessonNameLower) ||
                   frontText.includes(`lesson: ${lessonNameLower}`) || 
                   backText.includes(`from lesson: ${lessonNameLower}`);
          });
        });
      }
      
      // Apply lesson filter (check if front_text or back_text contains lesson name)
      if (lesson && lesson !== 'all') {
        filtered = filtered.filter(card => {
          if (!card) return false;
          const frontText = card.front_text?.toLowerCase() || '';
          const backText = card.back_text?.toLowerCase() || '';
          const lessonNameLower = lesson.toLowerCase();
          return frontText.includes(lessonNameLower) || backText.includes(lessonNameLower) || 
                 frontText.includes(`lesson: ${lessonNameLower}`) || backText.includes(`from lesson: ${lessonNameLower}`);
        });
      }
      
      // Apply regular shuffle for filtered cards
      if (shuffle) {
        filtered = filtered.sort(() => Math.random() - 0.5);
      }
    }
    
    setFilteredFlashCards(filtered);
    if (currentCardIndex >= filtered.length) {
      setCurrentCardIndex(0);
    }
  }, [selectedCategory, selectedCourseForFlashCards, selectedLessonForFlashCards, shuffleMode, shuffleAllLessons, currentCardIndex]);

  useEffect(() => {
    if (flashCardsOpen && flashCards.length > 0) {
      applyFilters(flashCards, selectedCategory, selectedCourseForFlashCards, selectedLessonForFlashCards, shuffleMode, shuffleAllLessons);
    } else if (flashCardsOpen && flashCards.length === 0) {
      setFilteredFlashCards([]);
    }
  }, [selectedCategory, selectedCourseForFlashCards, selectedLessonForFlashCards, shuffleMode, shuffleAllLessons, flashCards, flashCardsOpen, applyFilters]);

  // Get lessons for selected course in flash cards
  const getLessonsForFlashCardsCourse = () => {
    if (!selectedCourseForFlashCards) return [];
    const courseLessonsList = courseLessons[selectedCourseForFlashCards] || [];
    // Also include lessons from database that match the course
    const savedLessons = allLessons
      .filter(l => l.lessonName && !courseLessonsList.includes(l.lessonName))
      .map(l => l.lessonName);
    return [...courseLessonsList, ...savedLessons];
  };

  const handleFlipCard = () => {
    setIsFlipping(true);
    setTimeout(() => {
      setShowFlashCardBack(!showFlashCardBack);
      setIsFlipping(false);
    }, 150);
  };

  const handleCardRating = async (rating) => {
    const currentCard = filteredFlashCards[currentCardIndex];
    if (!currentCard) return;

    try {
      const token = localStorage.getItem('student_token');
      await axios.put(
        `${API_BASE_URL}/track-sheets/flash-cards/${currentCard.id}/review`,
        { masteryLevel: rating },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      
      // Update local state
      const updatedCards = flashCards.map(card =>
        card.id === currentCard.id
          ? { ...card, mastery_level: rating, times_reviewed: (card.times_reviewed || 0) + 1 }
          : card
      );
      setFlashCards(updatedCards);
      applyFilters(updatedCards, selectedCategory, selectedCourseForFlashCards, selectedLessonForFlashCards, shuffleMode, shuffleAllLessons);
      
      // Update stats
      const mastered = updatedCards.filter(c => c.mastery_level >= 3).length;
      setStudyStats({
        total: updatedCards.length,
        reviewed: updatedCards.filter(c => c.times_reviewed > 0).length,
        mastered: mastered,
      });
      
      // Move to next card after rating
      setTimeout(() => {
        nextFlashCard();
      }, 500);
    } catch (error) {
      console.error('Error updating card rating:', error);
      toast.error('Failed to update card rating');
    }
  };

  const saveLessonDetails = async () => {
    try {
      setSaving((prev) => ({ ...prev, lesson: true }));
      const token = localStorage.getItem('student_token');
      await axios.post(
        `${API_BASE_URL}/track-sheets/lesson-details`,
        {
          lessonName,
          points: lessonPoints.filter((p) => p.subject?.trim() !== '' || p.explanation?.trim() !== ''),
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      toast.success('Lesson details saved successfully!');
    } catch (error) {
      console.error('Error saving lesson details:', error);
      toast.error('Failed to save lesson details');
    } finally {
      setSaving((prev) => ({ ...prev, lesson: false }));
    }
  };

  const createFlashCardsFromLesson = async () => {
    try {
      if (!lessonName.trim()) {
        toast.error('Please enter a lesson name first');
        return;
      }

      const validPoints = lessonPoints.filter((p) => p.subject?.trim() !== '' || p.explanation?.trim() !== '');
      if (validPoints.length === 0) {
        toast.error('Please add at least one important point');
        return;
      }

      setCreatingFlashCards((prev) => ({ ...prev, lesson: true }));
      const token = localStorage.getItem('student_token');
      let createdCount = 0;

      // Create individual flash cards for each important point
      // Front: Subject (e.g., "VIRUS")
      // Back: Explanation (e.g., "IT IS NOTHING BUT A PROGRAM WHICH IS INTENDED FOR DESTROYING ANOTHER PROGRAM")
      for (const point of validPoints) {
        const subject = point.subject?.trim() || '';
        const explanation = point.explanation?.trim() || '';
        
        // Skip if both subject and explanation are empty
        if (!subject && !explanation) continue;
        
        // Only create card if both subject and explanation have content
        if (!subject || !explanation) {
          console.warn(`Skipping card: subject="${subject}", explanation="${explanation}" - both fields required`);
          continue;
        }
        
        await axios.post(
          `${API_BASE_URL}/track-sheets/flash-cards`,
          {
            frontText: subject,
            backText: explanation,
            category: 'lesson_details',
          },
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        createdCount++;
      }

      toast.success(`Created ${createdCount} flash card(s) from lesson details!`);
      loadFlashCards(); // Reload flash cards to show new ones
    } catch (error) {
      console.error('Error creating flash cards from lesson:', error);
      toast.error('Failed to create flash cards');
    } finally {
      setCreatingFlashCards((prev) => ({ ...prev, lesson: false }));
    }
  };

  const saveShortcuts = async () => {
    try {
      if (!lessonName.trim()) {
        toast.error('Please select a lesson first');
        return;
      }
      setSaving((prev) => ({ ...prev, shortcuts: true }));
      const token = localStorage.getItem('student_token');
      await axios.post(
        `${API_BASE_URL}/track-sheets/shortcuts`,
        {
          lessonName: lessonName.trim(),
          shortcuts: shortcuts.filter((s) => s.shortcut_key.trim() !== '' && s.use_case.trim() !== ''),
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      toast.success('Shortcuts saved successfully!');
    } catch (error) {
      console.error('Error saving shortcuts:', error);
      toast.error(error.response?.data?.message || 'Failed to save shortcuts');
    } finally {
      setSaving((prev) => ({ ...prev, shortcuts: false }));
    }
  };

  const createFlashCardsFromShortcuts = async () => {
    try {
      const validShortcuts = shortcuts.filter((s) => s.shortcut_key.trim() !== '' && s.use_case.trim() !== '');
      if (validShortcuts.length === 0) {
        toast.error('Please add at least one shortcut with both shortcut key and use case');
        return;
      }

      setCreatingFlashCards((prev) => ({ ...prev, shortcuts: true }));
      const token = localStorage.getItem('student_token');
      let createdCount = 0;

      // Create flash card for each shortcut
      for (const shortcut of validShortcuts) {
        await axios.post(
          `${API_BASE_URL}/track-sheets/flash-cards`,
          {
            frontText: shortcut.shortcut_key,
            backText: shortcut.use_case,
            category: 'shortcuts',
          },
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        createdCount++;
      }

      toast.success(`Created ${createdCount} flash card(s) from shortcuts!`);
      loadFlashCards(); // Reload flash cards to show new ones
    } catch (error) {
      console.error('Error creating flash cards from shortcuts:', error);
      toast.error('Failed to create flash cards');
    } finally {
      setCreatingFlashCards((prev) => ({ ...prev, shortcuts: false }));
    }
  };

  const saveSpeedPractice = async () => {
    try {
      setSaving((prev) => ({ ...prev, speed: true }));
      const token = localStorage.getItem('student_token');
      const validPractices = speedPractices.filter(
        (sp) => sp.lesson_name.trim() !== '' && sp.speed.trim() !== ''
      );

      if (validPractices.length === 0) {
        toast.warning('Please fill in at least one speed practice entry');
        setSaving((prev) => ({ ...prev, speed: false }));
        return;
      }

      for (const practice of validPractices) {
        await axios.post(
          `${API_BASE_URL}/track-sheets/speed-practice`,
          {
            practiceType: practice.practice_type || 'letters',
            lessonName: practice.lesson_name.trim(),
            speed: practice.speed.trim(),
          },
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
      }
      toast.success('Speed practice saved successfully!');
      // Reload today's track sheet to show updated data
      loadTodayTrackSheet();
    } catch (error) {
      console.error('Error saving speed practice:', error);
      const errorMessage = error.response?.data?.message || error.message || 'Failed to save speed practice';
      toast.error(errorMessage);
    } finally {
      setSaving((prev) => ({ ...prev, speed: false }));
    }
  };

  const saveExamResults = async () => {
    try {
      if (!lessonName.trim()) {
        toast.error('Please select a lesson first');
        return;
      }
      setSaving((prev) => ({ ...prev, exam: true }));
      const token = localStorage.getItem('student_token');
      const validResults = examResults.filter(
        (er) =>
          er.exam_name.trim() !== '' &&
          er.obtained_marks.trim() !== '' &&
          er.total_marks.trim() !== ''
      );

      if (validResults.length === 0) {
        toast.warning('Please fill in at least one exam result entry');
        setSaving((prev) => ({ ...prev, exam: false }));
        return;
      }

      // Validate all results first
      const currentLessonName = lessonName.trim();
      const validatedResults = [];

      for (const result of validResults) {
        const obtainedMarks = parseFloat(result.obtained_marks);
        const totalMarks = parseFloat(result.total_marks);

        // Validate marks
        if (isNaN(obtainedMarks) || isNaN(totalMarks)) {
          toast.error('Please enter valid numbers for marks');
          setSaving((prev) => ({ ...prev, exam: false }));
          return;
        }

        if (totalMarks <= 0) {
          toast.error('Total marks must be greater than 0');
          setSaving((prev) => ({ ...prev, exam: false }));
          return;
        }

        validatedResults.push({
          examName: currentLessonName, // Always use current lesson name
          obtainedMarks: obtainedMarks,
          totalMarks: totalMarks,
        });
      }

      // Save all exam results at once - backend will delete old ones for this lesson
      await axios.post(
        `${API_BASE_URL}/track-sheets/exam-results`,
        {
          examResults: validatedResults,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      toast.success('Exam results saved successfully!');
      // Reload lesson data to show updated exam results
      loadMainLessonData(currentLessonName);
    } catch (error) {
      console.error('Error saving exam results:', error);
      const errorMessage = error.response?.data?.message || error.message || 'Failed to save exam results';
      toast.error(errorMessage);
    } finally {
      setSaving((prev) => ({ ...prev, exam: false }));
    }
  };

  const addLessonPoint = () => {
    setLessonPoints([...lessonPoints, { subject: '', explanation: '' }]);
  };

  const removeLessonPoint = (index) => {
    setLessonPoints(lessonPoints.filter((_, i) => i !== index));
  };

  const addShortcut = () => {
    setShortcuts([...shortcuts, { shortcut_key: '', use_case: '' }]);
  };

  const removeShortcut = (index) => {
    setShortcuts(shortcuts.filter((_, i) => i !== index));
  };

  const addSpeedPractice = () => {
    setSpeedPractices([...speedPractices, { practice_type: 'letters', lesson_name: '', speed: '', custom_lesson_name: '' }]);
  };

  const removeSpeedPractice = (index) => {
    setSpeedPractices(speedPractices.filter((_, i) => i !== index));
  };

  const addExamResult = () => {
    setExamResults([...examResults, { exam_name: '', obtained_marks: '', total_marks: '' }]);
  };

  const removeExamResult = (index) => {
    setExamResults(examResults.filter((_, i) => i !== index));
  };

  const handleViewHistory = () => {
    navigate('/student/track-sheet/history');
  };

  const handleFlashCards = async () => {
    setFlashCardsOpen(true);
    setCurrentCardIndex(0);
    setShowFlashCardBack(false);
    // Set default course to selectedCourse if available
    if (selectedCourse && !selectedCourseForFlashCards) {
      setSelectedCourseForFlashCards(selectedCourse);
    }
    await loadFlashCards(); // Reload flash cards when opening dialog
  };

  const nextFlashCard = () => {
    if (filteredFlashCards.length === 0) return;
    setCurrentCardIndex((prev) => (prev + 1) % filteredFlashCards.length);
    setShowFlashCardBack(false);
  };

  const prevFlashCard = () => {
    if (filteredFlashCards.length === 0) return;
    setCurrentCardIndex((prev) => (prev - 1 + filteredFlashCards.length) % filteredFlashCards.length);
    setShowFlashCardBack(false);
  };

  const getCategoryColor = (category) => {
    const colors = {
      lesson_details: '#4CAF50',
      shortcuts: '#FF9800',
      default: '#2196F3',
    };
    return colors[category] || colors.default;
  };

  const getMasteryColor = (level) => {
    if (!level) return '#9E9E9E';
    if (level >= 3) return '#4CAF50'; // Mastered
    if (level === 2) return '#FF9800'; // Learning
    return '#F44336'; // Needs review
  };

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#f5f5f5' }}>
      {/* Professional Navigation Bar - Responsive */}
      <AppBar position="sticky" sx={{ bgcolor: 'primary.main', boxShadow: 3 }}>
        <Toolbar>
          <Container maxWidth="xl" sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', px: { xs: 1, sm: 2 } }}>
            {/* Logo/Brand */}
            <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: 1, sm: 2 } }}>
              <IconButton
                edge="start"
                color="inherit"
                aria-label="menu"
                onClick={() => setMobileMenuOpen(true)}
                sx={{ display: { xs: 'block', md: 'none' }, mr: 1 }}
              >
                <MenuIcon />
              </IconButton>
              <SchoolIcon sx={{ fontSize: { xs: 24, sm: 32 } }} />
              <Typography variant="h6" fontWeight="bold" sx={{ display: { xs: 'none', sm: 'block' }, fontSize: { xs: '0.9rem', sm: '1.25rem' } }}>
                KNLS Student Portal
              </Typography>
            </Box>

            {/* Navigation Links - Desktop */}
            <Box sx={{ display: { xs: 'none', md: 'flex' }, gap: 1, alignItems: 'center', flex: 1, justifyContent: 'center' }}>
              <Button
                color="inherit"
                startIcon={<HomeIcon />}
                onClick={() => navigate('/student/dashboard')}
                sx={{
                  '&:hover': { bgcolor: 'rgba(255,255,255,0.1)' },
                  fontWeight: location.pathname === '/student/dashboard' ? 'bold' : 'normal',
                }}
              >
                Home
              </Button>
              <Button
                color="inherit"
                startIcon={<AssignmentIcon />}
                onClick={() => navigate('/student/track-sheet')}
                sx={{
                  '&:hover': { bgcolor: 'rgba(255,255,255,0.1)' },
                  fontWeight: location.pathname === '/student/track-sheet' ? 'bold' : 'normal',
                  bgcolor: location.pathname === '/student/track-sheet' ? 'rgba(255,255,255,0.15)' : 'transparent',
                }}
              >
                Track Sheet
              </Button>
              <Button
                color="inherit"
                startIcon={<KeyboardIcon />}
                onClick={() => navigate('/student/typing-tutor')}
                sx={{
                  '&:hover': { bgcolor: 'rgba(255,255,255,0.1)' },
                  fontWeight: location.pathname.startsWith('/student/typing-tutor') ? 'bold' : 'normal',
                  bgcolor: location.pathname.startsWith('/student/typing-tutor') ? 'rgba(255,255,255,0.15)' : 'transparent',
                }}
              >
                Typing Tutor
              </Button>
              <Button
                color="inherit"
                startIcon={<HistoryIcon />}
                onClick={handleViewHistory}
                sx={{
                  '&:hover': { bgcolor: 'rgba(255,255,255,0.1)' },
                }}
              >
                History
              </Button>
              <Button
                color="inherit"
                startIcon={<FlashCardIcon />}
                onClick={handleFlashCards}
                sx={{
                  '&:hover': { bgcolor: 'rgba(255,255,255,0.1)' },
                }}
              >
                Flash Cards
              </Button>
              <Button
                color="inherit"
                startIcon={<EmojiEventsIcon />}
                onClick={() => navigate('/student/leaderboard')}
                sx={{
                  '&:hover': { bgcolor: 'rgba(255,255,255,0.1)' },
                  fontWeight: location.pathname === '/student/leaderboard' ? 'bold' : 'normal',
                  bgcolor: location.pathname === '/student/leaderboard' ? 'rgba(255,255,255,0.15)' : 'transparent',
                }}
              >
                Leaderboard
              </Button>
              <Button
                color="inherit"
                startIcon={<EmojiEventsIcon />}
                onClick={() => navigate('/student/statistics')}
                sx={{
                  '&:hover': { bgcolor: 'rgba(255,255,255,0.1)' },
                  fontWeight: location.pathname === '/student/statistics' ? 'bold' : 'normal',
                  bgcolor: location.pathname === '/student/statistics' ? 'rgba(255,255,255,0.15)' : 'transparent',
                }}
              >
                Today Topper
              </Button>
              <Button
                color="inherit"
                startIcon={<TrendingUpIcon />}
                onClick={() => navigate('/student/statistics')}
                sx={{
                  '&:hover': { bgcolor: 'rgba(255,255,255,0.1)' },
                }}
              >
                Statistics
              </Button>
            </Box>

            {/* User Menu */}
            <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: 0.5, sm: 1 } }}>
              <Typography variant="body2" sx={{ display: { xs: 'none', lg: 'block' }, fontSize: { xs: '0.75rem', sm: '0.875rem' } }}>
                {studentData?.name || 'Student'}
              </Typography>
              <IconButton
                onClick={handleMenuOpen}
                sx={{ color: 'white' }}
                size="small"
              >
                <Avatar 
                  sx={{ 
                    width: { xs: 28, sm: 32, md: 36 }, 
                    height: { xs: 28, sm: 32, md: 36 }, 
                    bgcolor: 'secondary.main' 
                  }}
                  src={studentData?.photo_url}
                >
                  {studentData?.photo_url ? null : (studentData?.name?.charAt(0)?.toUpperCase() || <PersonIcon />)}
                </Avatar>
              </IconButton>
              <Menu
                anchorEl={anchorEl}
                open={menuOpen}
                onClose={handleMenuClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
              >
                <MenuItem onClick={() => { navigate('/student/dashboard'); handleMenuClose(); }}>
                  <PersonIcon sx={{ mr: 1 }} /> Profile
                </MenuItem>
                <Divider />
                <MenuItem onClick={() => { handleLogout(); handleMenuClose(); }}>
                  <LogoutIcon sx={{ mr: 1 }} /> Logout
                </MenuItem>
              </Menu>
            </Box>
          </Container>
        </Toolbar>
      </AppBar>

      {/* Mobile Navigation Drawer */}
      <Drawer
        anchor="left"
        open={mobileMenuOpen}
        onClose={() => setMobileMenuOpen(false)}
        PaperProps={{
          sx: {
            width: 280,
            bgcolor: 'primary.main',
            color: 'white',
          }
        }}
      >
        <Box sx={{ p: 2, display: 'flex', alignItems: 'center', gap: 2, borderBottom: '1px solid rgba(255,255,255,0.2)' }}>
          <Avatar 
            sx={{ 
              width: 56, 
              height: 56, 
              bgcolor: 'secondary.main' 
            }}
            src={studentData?.photo_url}
          >
            {studentData?.photo_url ? null : (studentData?.name?.charAt(0)?.toUpperCase() || <PersonIcon />)}
          </Avatar>
          <Box>
            <Typography variant="h6" fontWeight="bold">
              {studentData?.name || 'Student'}
            </Typography>
            <Typography variant="caption" sx={{ opacity: 0.8 }}>
              {studentData?.student_id || ''}
            </Typography>
          </Box>
        </Box>
        <Box sx={{ p: 1 }}>
          <Button
            fullWidth
            color="inherit"
            startIcon={<HomeIcon />}
            onClick={() => { navigate('/student/dashboard'); setMobileMenuOpen(false); }}
            sx={{
              justifyContent: 'flex-start',
              mb: 0.5,
              '&:hover': { bgcolor: 'rgba(255,255,255,0.1)' },
            }}
          >
            Home
          </Button>
          <Button
            fullWidth
            color="inherit"
            startIcon={<AssignmentIcon />}
            onClick={() => { navigate('/student/track-sheet'); setMobileMenuOpen(false); }}
            sx={{
              justifyContent: 'flex-start',
              mb: 0.5,
              bgcolor: location.pathname === '/student/track-sheet' ? 'rgba(255,255,255,0.15)' : 'transparent',
              '&:hover': { bgcolor: 'rgba(255,255,255,0.1)' },
            }}
          >
            Track Sheet
          </Button>
          <Button
            fullWidth
            color="inherit"
            startIcon={<KeyboardIcon />}
            onClick={() => { navigate('/student/typing-tutor'); setMobileMenuOpen(false); }}
            sx={{
              justifyContent: 'flex-start',
              mb: 0.5,
              bgcolor: location.pathname.startsWith('/student/typing-tutor') ? 'rgba(255,255,255,0.15)' : 'transparent',
              '&:hover': { bgcolor: 'rgba(255,255,255,0.1)' },
            }}
          >
            Typing Tutor
          </Button>
          <Button
            fullWidth
            color="inherit"
            startIcon={<HistoryIcon />}
            onClick={() => { handleViewHistory(); setMobileMenuOpen(false); }}
            sx={{
              justifyContent: 'flex-start',
              mb: 0.5,
              '&:hover': { bgcolor: 'rgba(255,255,255,0.1)' },
            }}
          >
            History
          </Button>
          <Button
            fullWidth
            color="inherit"
            startIcon={<FlashCardIcon />}
            onClick={() => { handleFlashCards(); setMobileMenuOpen(false); }}
            sx={{
              justifyContent: 'flex-start',
              mb: 0.5,
              '&:hover': { bgcolor: 'rgba(255,255,255,0.1)' },
            }}
          >
            Flash Cards
          </Button>
          <Button
            fullWidth
            color="inherit"
            startIcon={<EmojiEventsIcon />}
            onClick={() => { navigate('/student/leaderboard'); setMobileMenuOpen(false); }}
            sx={{
              justifyContent: 'flex-start',
              mb: 0.5,
              '&:hover': { bgcolor: 'rgba(255,255,255,0.1)' },
              bgcolor: location.pathname === '/student/leaderboard' ? 'rgba(255,255,255,0.15)' : 'transparent',
            }}
          >
            Leaderboard
          </Button>
          <Button
            fullWidth
            color="inherit"
            startIcon={<EmojiEventsIcon />}
            onClick={() => { navigate('/student/statistics'); setMobileMenuOpen(false); }}
            sx={{
              justifyContent: 'flex-start',
              mb: 0.5,
              '&:hover': { bgcolor: 'rgba(255,255,255,0.1)' },
              bgcolor: location.pathname === '/student/statistics' ? 'rgba(255,255,255,0.15)' : 'transparent',
            }}
          >
            Today Topper
          </Button>
          <Button
            fullWidth
            color="inherit"
            startIcon={<TrendingUpIcon />}
            onClick={() => { navigate('/student/statistics'); setMobileMenuOpen(false); }}
            sx={{
              justifyContent: 'flex-start',
              mb: 0.5,
              '&:hover': { bgcolor: 'rgba(255,255,255,0.1)' },
            }}
          >
            Statistics
          </Button>
          <Divider sx={{ my: 2, bgcolor: 'rgba(255,255,255,0.2)' }} />
          <Button
            fullWidth
            color="inherit"
            startIcon={<LogoutIcon />}
            onClick={() => { handleLogout(); setMobileMenuOpen(false); }}
            sx={{
              justifyContent: 'flex-start',
              '&:hover': { bgcolor: 'rgba(255,255,255,0.1)' },
            }}
          >
            Logout
          </Button>
        </Box>
      </Drawer>

      {/* Main Content */}
      <Box sx={{ py: { xs: 2, sm: 3 }, px: { xs: 1, sm: 0 } }}>
        <Container maxWidth="xl">
          {/* Date and Time Header */}
          <Card sx={{ mb: { xs: 2, sm: 3 }, bgcolor: 'primary.main', color: 'white' }}>
            <CardContent sx={{ p: { xs: 2, sm: 3 } }}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: { xs: 'flex-start', sm: 'center' }, flexWrap: 'wrap', gap: 2 }}>
                <Box>
                  <Typography variant="h4" fontWeight="bold" gutterBottom sx={{ fontSize: { xs: '1.5rem', sm: '2rem' } }}>
                    Daily Track Sheet
                  </Typography>
                  <Typography variant="body1" sx={{ fontSize: { xs: '0.875rem', sm: '1rem' } }}>
                    Date: {new Date(currentDate).toLocaleDateString('en-IN', {
                      weekday: 'long',
                      year: 'numeric',
                      month: 'long',
                      day: 'numeric',
                    })}
                  </Typography>
                  <Typography variant="body2" sx={{ mt: 1, fontSize: { xs: '0.75rem', sm: '0.875rem' } }}>
                    Time: {currentTime}
                  </Typography>
                </Box>
              </Box>
            </CardContent>
          </Card>

          <LeaderboardDashboardCard />

          {/* Course Selection */}
          <Card sx={{ mb: { xs: 2, sm: 3 } }}>
            <CardContent>
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                <SchoolIcon color="primary" sx={{ mr: 1 }} />
                <Typography variant="h6" fontWeight="bold">
                  Select Course
                </Typography>
              </Box>
              <Divider sx={{ mb: 2 }} />
              <FormControl fullWidth>
                <InputLabel>Select Course</InputLabel>
                <Select
                  value={selectedCourse}
                  label="Select Course"
                  onChange={(e) => {
                    const course = e.target.value;
                    setSelectedCourse(course);
                    setSelectedMainLesson(''); // Clear lesson selection when course changes
                    setLessonName('');
                    setLessonPoints([{ subject: '', explanation: '' }]);
                    setShortcuts([{ shortcut_key: '', use_case: '' }]);
                    setExamResults([{ exam_name: '', obtained_marks: '', total_marks: '' }]);
                    loadTodayTrackSheet();
                  }}
                >
                  {availableCourses.map((course) => {
                    // Case-insensitive comparison - normalize both sides
                    const courseCodeUpper = course.code.toUpperCase().trim();
                    const isEnrolled = enrolledCourses.some(
                      enrolled => {
                        const enrolledUpper = String(enrolled || '').toUpperCase().trim();
                        return enrolledUpper === courseCodeUpper || 
                               enrolledUpper === course.code ||
                               String(enrolled) === course.code;
                      }
                    );
                    return (
                      <MenuItem 
                        key={course.code} 
                        value={course.code}
                        disabled={!isEnrolled}
                      >
                        {course.name} {!isEnrolled && '(Not Enrolled)'}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
              {selectedCourse && (
                <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                  Course: {availableCourses.find(c => c.code === selectedCourse)?.name}
                </Typography>
              )}
            </CardContent>
          </Card>

          {/* Main Lesson Selection - Applies to Sections 1, 2, 3 */}
          {selectedCourse && (
            <Card sx={{ mb: { xs: 2, sm: 3 } }}>
              <CardContent>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                  <BookIcon color="primary" sx={{ mr: 1 }} />
                  <Typography variant="h6" fontWeight="bold">
                    Select Lesson (Sections 1, 2, 3)
                  </Typography>
                </Box>
                <Divider sx={{ mb: 2 }} />
                <FormControl fullWidth>
                  <InputLabel>Select Lesson</InputLabel>
                  <Select
                    value={selectedMainLesson}
                    label="Select Lesson"
                    onChange={(e) => {
                      const selected = e.target.value;
                      setSelectedMainLesson(selected);
                      loadMainLessonData(selected);
                    }}
                    disabled={!selectedCourse}
                  >
                    <MenuItem value="">
                      <em>Select a lesson to begin</em>
                    </MenuItem>
                    {/* Course-specific lessons */}
                    {getLessonsForCourse().map((lesson, index) => (
                      <MenuItem key={`lesson-${index}`} value={lesson}>
                        {lesson}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                {selectedMainLesson && (
                  <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                    Selected lesson will be used for: Lesson Details, Shortcuts, and Exam Results
                  </Typography>
                )}
              </CardContent>
            </Card>
          )}

        <Grid container spacing={{ xs: 2, sm: 3 }}>
          {/* Section 1: Lesson Details */}
          <Grid item xs={12} md={6}>
            <Card>
              <CardContent>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                  <BookIcon color="primary" sx={{ mr: 1 }} />
                  <Typography variant="h6" fontWeight="bold">
                    Section 1: Lesson Details
                  </Typography>
                </Box>
                <Divider sx={{ mb: 2 }} />

                <TextField
                  fullWidth
                  label="Lesson Name"
                  value={lessonName}
                  onChange={(e) => {
                    setLessonName(e.target.value);
                    setSelectedMainLesson(''); // Clear main selection when manually typing
                  }}
                  sx={{ mb: 2 }}
                  placeholder="Select lesson from dropdown above"
                  disabled={!!selectedMainLesson}
                  helperText={selectedMainLesson ? 'Lesson selected from dropdown above' : 'Select a lesson from the dropdown above or enter manually'}
                />

                <Typography variant="subtitle2" sx={{ mb: 1 }}>
                  Important Points:
                </Typography>
                {lessonPoints.map((point, index) => (
                  <Box key={index} sx={{ display: 'flex', gap: 1, mb: 1, alignItems: 'flex-start' }}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Subject"
                      placeholder="e.g., HARDWARE"
                      value={point.subject || ''}
                      onChange={(e) => {
                        const newPoints = [...lessonPoints];
                        newPoints[index] = { ...newPoints[index], subject: e.target.value };
                        setLessonPoints(newPoints);
                      }}
                      sx={{ flex: 1 }}
                    />
                    <TextField
                      fullWidth
                      size="small"
                      label="Explanation"
                      placeholder="e.g., THE PHYSICAL COMPONENTS OF THE COMPUTER"
                      value={point.explanation || ''}
                      onChange={(e) => {
                        const newPoints = [...lessonPoints];
                        newPoints[index] = { ...newPoints[index], explanation: e.target.value };
                        setLessonPoints(newPoints);
                      }}
                      sx={{ flex: 1 }}
                      multiline
                      rows={2}
                    />
                    {lessonPoints.length > 1 && (
                      <IconButton
                        color="error"
                        onClick={() => removeLessonPoint(index)}
                        size="small"
                        sx={{ mt: 0.5 }}
                      >
                        <DeleteIcon />
                      </IconButton>
                    )}
                  </Box>
                ))}

                <Button
                  startIcon={<AddIcon />}
                  onClick={addLessonPoint}
                  sx={{ mb: 2 }}
                  size="small"
                >
                  Add Point
                </Button>

                <Box sx={{ display: 'flex', gap: 1 }}>
                  <Button
                    fullWidth
                    variant="contained"
                    color="primary"
                    startIcon={saving.lesson ? <CircularProgress size={20} /> : <SaveIcon />}
                    onClick={saveLessonDetails}
                    disabled={saving.lesson || !lessonName.trim()}
                  >
                    {saving.lesson ? 'Saving...' : 'Save Lesson Details'}
                  </Button>
                  <Button
                    variant="outlined"
                    color="secondary"
                    startIcon={creatingFlashCards.lesson ? <CircularProgress size={20} /> : <FlashCardIcon />}
                    onClick={createFlashCardsFromLesson}
                    disabled={creatingFlashCards.lesson || !lessonName.trim() || lessonPoints.filter((p) => p.subject?.trim() !== '' || p.explanation?.trim() !== '').length === 0}
                    title="Create flash cards from lesson details"
                  >
                    {creatingFlashCards.lesson ? 'Creating...' : 'Create Flash Cards'}
                  </Button>
                </Box>
              </CardContent>
            </Card>
          </Grid>

          {/* Section 2: Shortcuts */}
          <Grid item xs={12} md={6}>
            <Card>
              <CardContent>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                  <KeyboardIcon color="primary" sx={{ mr: 1 }} />
                  <Typography variant="h6" fontWeight="bold">
                    Section 2: Shortcuts
                  </Typography>
                </Box>
                <Divider sx={{ mb: 2 }} />
                {selectedMainLesson && (
                  <Alert severity="info" sx={{ mb: 2 }}>
                    Shortcuts for: <strong>{selectedMainLesson}</strong>
                  </Alert>
                )}

                {shortcuts.map((shortcut, index) => (
                  <Box key={index} sx={{ mb: 2 }}>
                    <Box sx={{ display: 'flex', gap: 1, mb: 1 }}>
                      <TextField
                        fullWidth
                        size="small"
                        label="Shortcut"
                        placeholder="e.g., Ctrl + A"
                        value={shortcut.shortcut_key}
                        onChange={(e) => {
                          const newShortcuts = [...shortcuts];
                          newShortcuts[index].shortcut_key = e.target.value;
                          setShortcuts(newShortcuts);
                        }}
                      />
                      {shortcuts.length > 1 && (
                        <IconButton
                          color="error"
                          onClick={() => removeShortcut(index)}
                          size="small"
                        >
                          <DeleteIcon />
                        </IconButton>
                      )}
                    </Box>
                    <TextField
                      fullWidth
                      size="small"
                      label="Use Case"
                      placeholder="e.g., for select all"
                      value={shortcut.use_case}
                      onChange={(e) => {
                        const newShortcuts = [...shortcuts];
                        newShortcuts[index].use_case = e.target.value;
                        setShortcuts(newShortcuts);
                      }}
                    />
                  </Box>
                ))}

                <Button
                  startIcon={<AddIcon />}
                  onClick={addShortcut}
                  sx={{ mb: 2 }}
                  size="small"
                >
                  Add Shortcut
                </Button>

                <Box sx={{ display: 'flex', gap: 1, flexDirection: { xs: 'column', sm: 'row' } }}>
                  <Button
                    fullWidth
                    variant="contained"
                    color="primary"
                    startIcon={saving.shortcuts ? <CircularProgress size={20} /> : <SaveIcon />}
                    onClick={saveShortcuts}
                    disabled={saving.shortcuts}
                    size={window.innerWidth < 600 ? 'small' : 'medium'}
                  >
                    {saving.shortcuts ? 'Saving...' : 'Save Shortcuts'}
                  </Button>
                  <Button
                    fullWidth={window.innerWidth < 600}
                    variant="outlined"
                    color="secondary"
                    startIcon={creatingFlashCards.shortcuts ? <CircularProgress size={20} /> : <FlashCardIcon />}
                    onClick={createFlashCardsFromShortcuts}
                    disabled={creatingFlashCards.shortcuts || shortcuts.filter((s) => s.shortcut_key.trim() !== '' && s.use_case.trim() !== '').length === 0}
                    title="Create flash cards from shortcuts"
                    size={window.innerWidth < 600 ? 'small' : 'medium'}
                  >
                    {creatingFlashCards.shortcuts ? 'Creating...' : 'Create Flash Cards'}
                  </Button>
                </Box>
              </CardContent>
            </Card>
          </Grid>

          {/* Section 3: Speed Practice */}
          <Grid item xs={12} md={6}>
            <Card>
              <CardContent>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                  <SpeedIcon color="primary" sx={{ mr: 1 }} />
                  <Typography variant="h6" fontWeight="bold">
                    Section 3: Keyboard Speed Practice
                  </Typography>
                </Box>
                <Divider sx={{ mb: 2 }} />
                <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                  Note: Speed Practice is independent - select lesson for each practice entry below
                </Typography>

                {speedPractices.map((practice, index) => (
                  <Box key={index} sx={{ mb: 2, p: 2, bgcolor: '#f9f9f9', borderRadius: 1 }}>
                    <Box sx={{ display: 'flex', gap: 1, mb: 1 }}>
                      <FormControl fullWidth size="small">
                        <InputLabel>Practice Type</InputLabel>
                        <Select
                          value={practice.practice_type}
                          label="Practice Type"
                          onChange={(e) => {
                            const newPractices = [...speedPractices];
                            newPractices[index].practice_type = e.target.value;
                            setSpeedPractices(newPractices);
                          }}
                        >
                          <MenuItem value="letters">Letters</MenuItem>
                          <MenuItem value="words">Words</MenuItem>
                          <MenuItem value="sentences">Sentences</MenuItem>
                        </Select>
                      </FormControl>
                      {speedPractices.length > 1 && (
                        <IconButton
                          color="error"
                          onClick={() => removeSpeedPractice(index)}
                          size="small"
                        >
                          <DeleteIcon />
                        </IconButton>
                      )}
                    </Box>
                    <FormControl fullWidth size="small" sx={{ mb: 1 }}>
                      <InputLabel>Practice Lesson Name</InputLabel>
                      <Select
                        value={practice.lesson_name}
                        label="Practice Lesson Name"
                        onChange={(e) => {
                          const newPractices = [...speedPractices];
                          newPractices[index].lesson_name = e.target.value;
                          setSpeedPractices(newPractices);
                        }}
                      >
                        <MenuItem value="">
                          <em>Select a lesson</em>
                        </MenuItem>
                        <MenuItem value="1 - FUNDAMENTALS HW VS SW">
                          → 1 - FUNDAMENTALS HW VS SW
                        </MenuItem>
                        <MenuItem value="2 - FUNDAMENTALS QWERTY KEYBOARD">
                          → 2 - FUNDAMENTALS QWERTY KEYBOARD
                        </MenuItem>
                        <MenuItem value="custom">
                          <em>Custom (Enter manually)</em>
                        </MenuItem>
                      </Select>
                    </FormControl>
                    {practice.lesson_name === 'custom' && (
                      <TextField
                        fullWidth
                        size="small"
                        label="Custom Lesson Name"
                        placeholder="e.g., aq (for letters)"
                        value={practice.custom_lesson_name || ''}
                        onChange={(e) => {
                          const newPractices = [...speedPractices];
                          if (!newPractices[index].custom_lesson_name) {
                            newPractices[index].custom_lesson_name = '';
                          }
                          newPractices[index].custom_lesson_name = e.target.value;
                          newPractices[index].lesson_name = e.target.value;
                          setSpeedPractices(newPractices);
                        }}
                        sx={{ mb: 1 }}
                      />
                    )}
                    <TextField
                      fullWidth
                      size="small"
                      label="Speed"
                      placeholder="e.g., 10wpm, 35wpm"
                      value={practice.speed}
                      onChange={(e) => {
                        const newPractices = [...speedPractices];
                        newPractices[index].speed = e.target.value;
                        setSpeedPractices(newPractices);
                      }}
                    />
                  </Box>
                ))}

                <Button
                  startIcon={<AddIcon />}
                  onClick={addSpeedPractice}
                  sx={{ mb: 2 }}
                  size="small"
                >
                  Add Practice
                </Button>

                <Button
                  fullWidth
                  variant="contained"
                  color="primary"
                  startIcon={saving.speed ? <CircularProgress size={20} /> : <SaveIcon />}
                  onClick={saveSpeedPractice}
                  disabled={saving.speed}
                >
                  {saving.speed ? 'Saving...' : 'Save Speed Practice'}
                </Button>
              </CardContent>
            </Card>
          </Grid>

          {/* Section 4: Exam/Quiz Results */}
          <Grid item xs={12} md={6}>
            <Card>
              <CardContent>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                  <AssignmentIcon color="primary" sx={{ mr: 1 }} />
                  <Typography variant="h6" fontWeight="bold">
                    Section 4: Exam/Quiz Results
                  </Typography>
                </Box>
                <Divider sx={{ mb: 2 }} />

                {examResults.map((result, index) => (
                  <Box key={index} sx={{ mb: 2, p: 2, bgcolor: '#f9f9f9', borderRadius: 1 }}>
                    <Box sx={{ display: 'flex', gap: 1, mb: 1 }}>
                      <TextField
                        fullWidth
                        size="small"
                        label="Exam Name (Lesson Name)"
                        placeholder="e.g., MS Word Basics"
                        value={result.exam_name}
                        onChange={(e) => {
                          const newResults = [...examResults];
                          newResults[index].exam_name = e.target.value;
                          setExamResults(newResults);
                        }}
                      />
                      {examResults.length > 1 && (
                        <IconButton
                          color="error"
                          onClick={() => removeExamResult(index)}
                          size="small"
                        >
                          <DeleteIcon />
                        </IconButton>
                      )}
                    </Box>
                    <Box sx={{ display: 'flex', gap: 1 }}>
                      <TextField
                        fullWidth
                        size="small"
                        label="Obtained Marks"
                        type="number"
                        value={result.obtained_marks}
                        onChange={(e) => {
                          const newResults = [...examResults];
                          newResults[index].obtained_marks = e.target.value;
                          setExamResults(newResults);
                        }}
                      />
                      <TextField
                        fullWidth
                        size="small"
                        label="Total Marks"
                        type="number"
                        value={result.total_marks}
                        onChange={(e) => {
                          const newResults = [...examResults];
                          newResults[index].total_marks = e.target.value;
                          setExamResults(newResults);
                        }}
                      />
                    </Box>
                    {result.obtained_marks && result.total_marks && (
                      <Typography variant="body2" color="primary" sx={{ mt: 1 }}>
                        Percentage:{' '}
                        {((parseFloat(result.obtained_marks) / parseFloat(result.total_marks)) * 100).toFixed(2)}%
                      </Typography>
                    )}
                  </Box>
                ))}

                <Button
                  startIcon={<AddIcon />}
                  onClick={addExamResult}
                  sx={{ mb: 2 }}
                  size="small"
                >
                  Add Exam Result
                </Button>

                <Button
                  fullWidth
                  variant="contained"
                  color="primary"
                  startIcon={saving.exam ? <CircularProgress size={20} /> : <SaveIcon />}
                  onClick={saveExamResults}
                  disabled={saving.exam}
                >
                  {saving.exam ? 'Saving...' : 'Save Exam Results'}
                </Button>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
        </Container>
      </Box>

      {/* Enhanced Flash Cards Dialog - Responsive */}
      <Dialog 
        open={flashCardsOpen} 
        onClose={() => setFlashCardsOpen(false)} 
        maxWidth="md" 
        fullWidth
        fullScreen={window.innerWidth < 600}
        PaperProps={{
          sx: {
            borderRadius: { xs: 0, sm: 3 },
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            m: { xs: 0, sm: 2 },
            maxHeight: { xs: '100vh', sm: '90vh' },
          }
        }}
      >
        <DialogTitle sx={{ bgcolor: 'transparent', color: 'white', pb: 1 }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Box>
              <Typography variant="h5" fontWeight="bold" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <SchoolIcon /> Flash Cards Study
              </Typography>
              <Typography variant="caption" sx={{ opacity: 0.9 }}>
                {filteredFlashCards.length} card{filteredFlashCards.length !== 1 ? 's' : ''} available
              </Typography>
            </Box>
            <IconButton onClick={() => setFlashCardsOpen(false)} sx={{ color: 'white' }}>
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        
        <DialogContent sx={{ bgcolor: '#f5f7fa', minHeight: { xs: 'calc(100vh - 200px)', sm: 500 }, p: { xs: 2, sm: 3 } }}>
          {/* Stats Bar */}
          {studyStats.total > 0 && (
            <Box sx={{ mb: 2, display: 'flex', gap: { xs: 1, sm: 2 }, flexWrap: 'wrap' }}>
              <Chip 
                icon={<TrendingUpIcon />}
                label={`Total: ${studyStats.total}`}
                color="primary"
                variant="outlined"
                size={window.innerWidth < 600 ? 'small' : 'medium'}
              />
              <Chip 
                label={`Reviewed: ${studyStats.reviewed}`}
                color="info"
                variant="outlined"
                size={window.innerWidth < 600 ? 'small' : 'medium'}
              />
              <Chip 
                label={`Mastered: ${studyStats.mastered}`}
                color="success"
                variant="outlined"
                size={window.innerWidth < 600 ? 'small' : 'medium'}
              />
            </Box>
          )}

          {/* Filters */}
          <Box sx={{ mb: 2, display: 'flex', gap: { xs: 1, sm: 2 }, flexWrap: 'wrap', alignItems: 'center' }}>
            <FormControl size="small" sx={{ minWidth: { xs: '100%', sm: 150 }, maxWidth: { xs: '100%', sm: 'none' } }}>
              <InputLabel>Course</InputLabel>
              <Select
                value={selectedCourseForFlashCards}
                label="Course"
                onChange={(e) => {
                  setSelectedCourseForFlashCards(e.target.value);
                  setSelectedLessonForFlashCards('all'); // Reset lesson when course changes
                }}
              >
                <MenuItem value="">All Courses</MenuItem>
                {availableCourses
                  .filter(course => enrolledCourses.some(
                    enrolled => String(enrolled || '').toUpperCase().trim() === course.code.toUpperCase().trim()
                  ))
                  .map((course) => (
                    <MenuItem key={course.code} value={course.code}>
                      {course.name}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
            <FormControl size="small" sx={{ minWidth: { xs: '100%', sm: 150 }, maxWidth: { xs: '100%', sm: 'none' } }}>
              <InputLabel>Category</InputLabel>
              <Select
                value={selectedCategory}
                label="Category"
                onChange={(e) => setSelectedCategory(e.target.value)}
              >
                <MenuItem value="all">All Categories</MenuItem>
                <MenuItem value="lesson_details">Lesson Details</MenuItem>
                <MenuItem value="shortcuts">Shortcuts</MenuItem>
              </Select>
            </FormControl>
            <FormControl size="small" sx={{ minWidth: { xs: '100%', sm: 180 }, maxWidth: { xs: '100%', sm: 'none' } }}>
              <InputLabel>Lesson</InputLabel>
              <Select
                value={selectedLessonForFlashCards}
                label="Lesson"
                onChange={(e) => setSelectedLessonForFlashCards(e.target.value)}
                disabled={!selectedCourseForFlashCards}
              >
                <MenuItem value="all">All Lessons</MenuItem>
                {selectedCourseForFlashCards && getLessonsForFlashCardsCourse().map((lesson, index) => (
                  <MenuItem key={`flashcard-lesson-${index}`} value={lesson}>
                    {lesson}
                  </MenuItem>
                ))}
              </Select>
              {!selectedCourseForFlashCards && (
                <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5, display: 'block' }}>
                  Please select a course first
                </Typography>
              )}
            </FormControl>
            <Button
              variant={shuffleMode ? 'contained' : 'outlined'}
              startIcon={<ShuffleIcon />}
              onClick={() => {
                setShuffleMode(!shuffleMode);
                setShuffleAllLessons(false); // Disable shuffle all when enabling regular shuffle
              }}
              size="small"
              fullWidth={window.innerWidth < 600}
            >
              {shuffleMode ? 'Shuffled' : 'Shuffle'}
            </Button>
            <Button
              variant={shuffleAllLessons ? 'contained' : 'outlined'}
              startIcon={<ShuffleIcon />}
              onClick={() => {
                setShuffleAllLessons(!shuffleAllLessons);
                setShuffleMode(false); // Disable regular shuffle when enabling shuffle all
              }}
              size="small"
              color={shuffleAllLessons ? 'secondary' : 'primary'}
              fullWidth={window.innerWidth < 600}
              title="Shuffle cards from all lessons randomly"
            >
              {shuffleAllLessons ? 'Shuffle All On' : 'Shuffle All'}
            </Button>
            <Button
              variant="outlined"
              startIcon={<RefreshIcon />}
              onClick={loadFlashCards}
              size="small"
              fullWidth={window.innerWidth < 600}
            >
              Refresh
            </Button>
          </Box>

          {filteredFlashCards.length === 0 ? (
            <Alert severity="info" sx={{ mt: 4 }}>
              {flashCards.length === 0 
                ? 'No flash cards available. Create some from your track sheets!'
                : 'No flash cards match the selected filter.'}
            </Alert>
          ) : (
            <Box sx={{ textAlign: 'center', py: 2 }}>
              {/* Flash Card */}
              <Box
                sx={{
                  perspective: '1000px',
                  mb: 3,
                }}
              >
                <Box
                  sx={{
                    position: 'relative',
                    width: '100%',
                    minHeight: 300,
                    transformStyle: 'preserve-3d',
                    transition: 'transform 0.6s',
                    transform: showFlashCardBack ? 'rotateY(180deg)' : 'rotateY(0deg)',
                    cursor: 'pointer',
                  }}
                  onClick={handleFlipCard}
                >
                  {/* Front of Card */}
                  <Paper
                    sx={{
                      position: 'absolute',
                      width: '100%',
                      height: '100%',
                      backfaceVisibility: 'hidden',
                      p: { xs: 2, sm: 4 },
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      background: `linear-gradient(135deg, ${getCategoryColor(filteredFlashCards[currentCardIndex]?.category)} 0%, ${getCategoryColor(filteredFlashCards[currentCardIndex]?.category)}dd 100%)`,
                      color: 'white',
                      borderRadius: { xs: 2, sm: 3 },
                      boxShadow: '0 10px 40px rgba(0,0,0,0.2)',
                      minHeight: { xs: 250, sm: 300 },
                    }}
                  >
                    <Chip
                      label={filteredFlashCards[currentCardIndex]?.category?.replace('_', ' ') || 'Flash Card'}
                      sx={{ mb: 2, bgcolor: 'rgba(255,255,255,0.2)', color: 'white' }}
                      size="small"
                    />
                    <Typography 
                      variant="h5" 
                      fontWeight="bold"
                      sx={{ 
                        wordBreak: 'break-word',
                        textAlign: 'center',
                        px: { xs: 1, sm: 2 },
                        fontSize: { xs: '1.25rem', sm: '1.5rem' },
                      }}
                    >
                      {filteredFlashCards[currentCardIndex]?.front_text || 'No card'}
                    </Typography>
                    <Typography variant="caption" sx={{ mt: 2, opacity: 0.8, fontSize: { xs: '0.7rem', sm: '0.75rem' } }}>
                      Click to flip
                    </Typography>
                  </Paper>

                  {/* Back of Card */}
                  <Paper
                    sx={{
                      position: 'absolute',
                      width: '100%',
                      height: '100%',
                      backfaceVisibility: 'hidden',
                      transform: 'rotateY(180deg)',
                      p: { xs: 2, sm: 4 },
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      background: `linear-gradient(135deg, #667eea 0%, #764ba2 100%)`,
                      color: 'white',
                      borderRadius: { xs: 2, sm: 3 },
                      boxShadow: '0 10px 40px rgba(0,0,0,0.2)',
                      minHeight: { xs: 250, sm: 300 },
                    }}
                  >
                    <Typography 
                      variant="h6" 
                      sx={{ 
                        wordBreak: 'break-word',
                        textAlign: 'center',
                        whiteSpace: 'pre-line',
                        px: { xs: 1, sm: 2 },
                        fontSize: { xs: '1rem', sm: '1.25rem' },
                      }}
                    >
                      {filteredFlashCards[currentCardIndex]?.back_text || 'No answer'}
                    </Typography>
                    {filteredFlashCards[currentCardIndex]?.mastery_level && (
                      <Box sx={{ mt: 2, display: 'flex', gap: 0.5 }}>
                        {[1, 2, 3].map((level) => (
                          <StarIcon
                            key={level}
                            sx={{
                              color: level <= filteredFlashCards[currentCardIndex].mastery_level
                                ? '#FFD700'
                                : 'rgba(255,255,255,0.3)',
                              fontSize: { xs: 18, sm: 20 },
                            }}
                          />
                        ))}
                      </Box>
                    )}
                  </Paper>
                </Box>
              </Box>

              {/* Card Info */}
              <Box sx={{ mb: 3 }}>
                <Typography variant="body2" color="text.secondary">
                  Card {currentCardIndex + 1} of {filteredFlashCards.length}
                </Typography>
                {filteredFlashCards[currentCardIndex]?.times_reviewed > 0 && (
                  <Typography variant="caption" color="text.secondary">
                    Reviewed {filteredFlashCards[currentCardIndex].times_reviewed} time(s)
                  </Typography>
                )}
              </Box>

              {/* Rating Buttons */}
              <Box sx={{ display: 'flex', gap: { xs: 0.5, sm: 1 }, justifyContent: 'center', mb: 2, flexWrap: 'wrap' }}>
                <Button
                  variant="outlined"
                  color="error"
                  size={window.innerWidth < 600 ? 'small' : 'medium'}
                  onClick={() => handleCardRating(1)}
                  disabled={!showFlashCardBack}
                  fullWidth={window.innerWidth < 600}
                >
                  Needs Review
                </Button>
                <Button
                  variant="outlined"
                  color="warning"
                  size={window.innerWidth < 600 ? 'small' : 'medium'}
                  onClick={() => handleCardRating(2)}
                  disabled={!showFlashCardBack}
                  fullWidth={window.innerWidth < 600}
                >
                  Learning
                </Button>
                <Button
                  variant="outlined"
                  color="success"
                  size={window.innerWidth < 600 ? 'small' : 'medium'}
                  onClick={() => handleCardRating(3)}
                  disabled={!showFlashCardBack}
                  fullWidth={window.innerWidth < 600}
                >
                  Mastered
                </Button>
              </Box>

              {/* Navigation */}
              <Box sx={{ display: 'flex', gap: { xs: 1, sm: 2 }, justifyContent: 'center', flexWrap: 'wrap' }}>
                <Button
                  variant="outlined"
                  startIcon={<ArrowBackIcon />}
                  onClick={prevFlashCard}
                  disabled={filteredFlashCards.length === 0}
                  size={window.innerWidth < 600 ? 'small' : 'medium'}
                  fullWidth={window.innerWidth < 600}
                  sx={{
                    bgcolor: 'white',
                    '&:hover': { bgcolor: '#f0f0f0' },
                    boxShadow: 2,
                  }}
                >
                  Previous
                </Button>
                <Button
                  variant="outlined"
                  startIcon={<RefreshIcon />}
                  onClick={handleFlipCard}
                  size={window.innerWidth < 600 ? 'small' : 'medium'}
                  fullWidth={window.innerWidth < 600}
                  sx={{
                    bgcolor: 'white',
                    '&:hover': { bgcolor: '#f0f0f0' },
                    boxShadow: 2,
                  }}
                >
                  Flip
                </Button>
                <Button
                  variant="contained"
                  endIcon={<ArrowForwardIcon />}
                  onClick={nextFlashCard}
                  disabled={filteredFlashCards.length === 0}
                  size={window.innerWidth < 600 ? 'small' : 'medium'}
                  fullWidth={window.innerWidth < 600}
                  sx={{
                    boxShadow: 2,
                  }}
                >
                  Next
                </Button>
              </Box>
            </Box>
          )}
        </DialogContent>
        <DialogActions sx={{ bgcolor: '#f5f7fa', px: 3, py: 2 }}>
          <Button onClick={() => setFlashCardsOpen(false)} variant="outlined">
            Close
          </Button>
        </DialogActions>
      </Dialog>

      <LmsLeaderboardLoginPopup
        open={showLeaderboardPopup}
        onClose={() => setShowLeaderboardPopup(false)}
        currentPhone={studentData?.phone}
      />
    </Box>
  );
};

export default DailyTrackSheet;

